import Css from "./style.module.scss";

import { checkDocumentsFetching } from "selectors/documents";
import { getTextsData } from "selectors/texts";
import { useSelector } from "react-redux";
import HeaderButtons from "../../../HeaderButtons";
import NoDataContent from "nlib/common/NoDataContent";
import Preloader from "nlib/common/Preloader";
import React, { useMemo } from "react";
import useEnvVars from "hooks/useEnvVars";

const EmptyState = ({ uploadDocumentsWindowOpened, onUploadDocumentsOpen }) => {
  const [{ text, fromDate, toDate, accountId, type, status }] = useEnvVars();

  const { uiTexts, messages } = useSelector(getTextsData);

  const fetchingData = useSelector(checkDocumentsFetching);

  const filtersEnabled = useMemo(() => {
    return !![text, fromDate, toDate, accountId, type].find(Boolean);
  }, [text, fromDate, toDate, accountId, type]);

  return (
    <div className={Css.emptyState}>
      {fetchingData ? <Preloader /> : (
        <NoDataContent
          title={status && !filtersEnabled
            ? messages.noDocumentsWithThisStatus
            : uiTexts.noDocuments}>
          {!filtersEnabled && (
            <HeaderButtons
              hideUploadButton={uploadDocumentsWindowOpened}
              onUploadDocumentsOpen={onUploadDocumentsOpen} />
          )}
        </NoDataContent>
      )}
    </div>
  );
};

export default React.memo(EmptyState);
